export default function processQuestions(botData: Record<string, any>) {
  const botInitNode = {
    label: "bot-init",
    question: botData.aiBotConfig?.botInitMessage || "Hey, how can I help you?",
  };
  const aiNode = {
    label: "AI",
    question: "AI Node",
  };

  const nodeData = [botInitNode, aiNode];

  if (
    botData.aiBotConfig?.collectUserData ||
    botData.aiBotConfig?.containsLiveChat
  ) {
    nodeData.splice(1, 0, ...(botData.aiBotConfig.questions ?? []));
  }

  const questions: any[] = [];

  for (const index in nodeData) {
    const { label, question } = nodeData[index];
    const id = +index + 1;
    const node: Record<string, any> = {
      drawFlowId: id,
      pos_x: id * 50,
      pos_y: id * 50,
      nodeType: "default",
      data: {
        title: question,
      },
      inputs: {
        connectionId: "input_1",
        connections:
          id === 1
            ? []
            : [
                {
                  node: id - 1,
                  input: "output_1",
                },
              ],
      },
      outputs: [
        {
          connectionId: "output_1",
          ...(id !== nodeData.length && {
            connections: {
              node: id + 1,
              output: "input_1",
            },
          }),
        },
      ],
    };

    let extra: Record<string, any>;
    if (
      label.includes("Email") ||
      label.includes("Name") ||
      label.includes("Phone") ||
      label.includes("Company") ||
      label.includes("Job") ||
      label.includes("Address")
    ) {
      extra = {
        name: label.toLowerCase(),
        class: label.toLowerCase(),
        tagName: label,
        hasVariable: true,
        variableName: `${id}_${label.toLowerCase()}`,
      };
    } else if (label === "AI") {
      extra = {
        name: "ai",
        class: "ai",
      };
    } else if (label === "bot-init" || label === "ai-init") {
      extra = {
        name: "sendMessage",
        class: "sendMessage",
        hasVariable: false,
        variableName: `${id}_sendMessage`,
      };
    } else if (label === "liveChat") {
      extra = {
        name: "liveChat",
        class: "liveChat",
        hasVariable: false,
        variableName: `${id}_liveChat`,
        liveChatData: {
          ...question?.extraData?.liveChatData,
          useAssigneesAsAgents: false,
        },
      };
    } else {
      extra = {
        name: "ask_question",
        class: "ask_question",
        variableName: `${id}_ask_question`,
        tagName: label,
      };
    }
    questions.push({ ...node, ...extra });
  }

  return questions;
}
